<template>
  <div class="knowledge-directory" style="height:100%;overflow:auto;" @click="handleClickOutside">
    <BaseEmpty v-if="!treeDirs || treeDirs.length === 0" type="empty-item" msg="暂无目录" />
    <div v-else class="directory-tree" @click.stop>
      <directory-node
        v-for="dir in treeDirs"
        :key="dir.id"
        :dir="dir"
        :selected-dir="selectedDir"
        :level="0"
        @on-select="handleSelect"
        @on-drop-in="handleDropIn"
      />
    </div>
  </div>
</template>

<script>
import BaseEmpty from '@/components/base/Empty';
import UTIL from '@/utils';
import DirectoryNode from './directory-node';
export default {
  components: {BaseEmpty, DirectoryNode},
  props: {
    dirs: {
      type: Array,
      default: () => [],
    },
    selectedDir: {
      type: Object,
      default: null,
    },
  },
  computed: {
    treeDirs() {
      if (!this.dirs || this.dirs.length === 0) return [];
      return UTIL.makeTree(this.dirs, {
        KEY: 'id',
        PARENT_KEY: 'parent_id',
        LIST_KEY: 'subs',
      });
    },
  },
  methods: {
    handleSelect(dir) {
      this.$emit('on-select', dir);
    },
    handleDropIn(data) {
      this.$emit('on-drop-in', data);
      // 同时触发文件拖拽事件，让父组件判断是否是文件
      this.$emit('on-drop-file', data);
    },
    handleClickOutside(e) {
      // 点击空白处取消选择
      if (e.target === this.$el || e.target.classList.contains('knowledge-directory')) {
        this.$emit('on-select', null);
      }
    },
  },
};
</script>

<style lang="less" scoped>

.directory-tree {
  .directory-item {
    padding: 8px 10px;
    margin: 2px 0;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    user-select: none;

    &:hover {
      background: var(--border);
    }

    &.selected {
      background: var(--primary);
      color: #fff;

      .link-badge {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    .directory-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .link-badge {
      font-size: 10px;
      padding: 2px 6px;
      background: var(--subtext3);
      color: #fff;
      border-radius: 2px;
      margin-left: 5px;
    }
  }
}

.ugo-draggable {
  opacity: 0.5;
}

.ugo-droppable {
  background: var(--primary-light) !important;
  border: 2px dashed var(--primary) !important;
}
</style>
